import Edit from './Edit'
import Overview from './Overview'
import Base from './Base'

export default {
    Edit,
    Overview,
    Base
}


// WEBPACK FOOTER //
// ./src/views/admin/branches/index.js